module.exports = __webpack_public_path__ + "static/media/logo_english.d5b0248c.svg";